import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { base44 } from "@/api/base44Client";
import { useApp } from "@/lib/AppContext";

const T = {
  ar: { wheelBtn: "🎡 جرّب حظك واربح عروضاً", wheelSub: "العب عجلة العروض وربح خصومات وهدايا مميزة" },
  en: { wheelBtn: "🎡 Try Your Luck & Win Offers", wheelSub: "Spin the wheel and win discounts and special gifts" }
};

export default function PromoSection() {
  const { lang } = useApp();
  const tr = T[lang] || T.ar;
  const isAr = lang === "ar";
  const [promos, setPromos] = useState([]);

  useEffect(() => {
    base44.entities.PromoImage.filter({ is_active: true }, "sort_order", 5)
      .then(setPromos).catch(() => {});
  }, []);

  return (
    <section className="py-16 bg-background" dir={isAr ? "rtl" : "ltr"}>
      <div className="max-w-6xl mx-auto px-4 space-y-8">

        {/* Promo Images from Dashboard */}
        {promos.length > 0 && (
          <div className={`grid gap-5 ${promos.length === 1 ? "grid-cols-1" : "grid-cols-1 sm:grid-cols-2"}`}>
            {promos.map(p => (
              <a key={p.id} href={p.link_url || "#"} target={p.link_url ? "_blank" : "_self"}
                rel="noopener noreferrer"
                className="block rounded-3xl overflow-hidden shadow-xl hover:shadow-2xl transition-all hover:scale-[1.01] group">
                <div className="relative">
                  <img src={p.image_url} alt={isAr ? p.title : (p.title_en || p.title)}
                    className="w-full object-cover max-h-72" />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent" />
                  <div className="absolute bottom-4 start-4 end-4">
                    <p className="text-white font-black text-xl drop-shadow-lg">
                      {isAr ? p.title : (p.title_en || p.title)}
                    </p>
                  </div>
                </div>
              </a>
            ))}
          </div>
        )}

        {/* Wheel CTA Card */}
        <div className="relative rounded-3xl overflow-hidden bg-gradient-to-br from-[#1E5FA8] to-[#0e3060] p-8 lg:p-12 text-white text-center shadow-2xl">
          <div className="absolute top-0 right-0 w-64 h-64 bg-white/5 rounded-full -translate-y-1/2 translate-x-1/3" />
          <div className="absolute bottom-0 left-0 w-48 h-48 bg-white/5 rounded-full translate-y-1/2 -translate-x-1/3" />
          <div className="relative z-10">
            <div className="text-6xl mb-4">🎡</div>
            <h2 className="text-2xl lg:text-3xl font-black mb-3">{tr.wheelBtn}</h2>
            <p className="text-white/70 mb-6 max-w-md mx-auto">{tr.wheelSub}</p>
            <Link to="/wheel"
              className="inline-flex items-center gap-2 bg-white text-[#1E5FA8] font-black px-8 py-3.5 rounded-2xl hover:opacity-90 transition-all shadow-xl text-sm hover:scale-105">
              {isAr ? "ابدأ الآن" : "Start Now"} ✨
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}